/* ================================================== */
/* COOKIE BANNER
/* ================================================== */

$(document).ready(function() {
	var $cookieBanner = $('#cookie-banner'),
		name = 'cookieconsent_status',
		duration = 365;

	if ($cookieBanner.length && typeof Cookies.get(name) === 'undefined') {
		$('.cookie-banner-button', $cookieBanner).click(function() {
			// Status
			var status = ($(this).data('consent') == 'allow') ? 'allowed' : 'declined';

			// Hide banner
			$cookieBanner.addClass('cookie-banner-closed');

			// Apply cookie
			Cookies.set(name, status, { expires: duration });

			// Inject analytics scripts
			if (status == 'allowed') {
				$.ajax({
					url: '/resources/analytics',
					success: function(data) {
						$('body').append(data);
					},
					error: function(response) {
						console.log(response);
						location.reload();
					},
					dataType: 'html'
				});
			}
		});
	}
});